import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from '@env/environment'
import { ToastrService } from 'ngx-toastr'
import { FormControl, FormGroup } from '@angular/forms'
import { Retest, RetestBulkOperation } from 'app/models/retest/retest'
import { RetestSearch } from 'app/models/retest/retest-search'
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload'
import { BulkJob } from 'app/models/bulkJobs/bulkJob'

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

@Injectable({
  providedIn: 'root'
})

export class RetestService {
  currentYear = new Date().getFullYear();
  fullPanel = "FullPanel";
  nitrateOnly = "NitrateOnly";
  testTypeInitial = "Initial";
  testTypeAnnual = "Annual";
  testTypeQuarterly = "Quarterly";

  tiers: {id: number }[] = [
    { id: 1 }, 
    { id: 2 },
    { id: 3 },
    { id: 4 }
  ];

  retestQuarters: {id: number }[] = [
    { id: 1 }, 
    { id: 2 },
    { id: 3 },
    { id: 4 }
  ];

  retestYears: {id: number }[] = [
    { id: this.currentYear - 1 }, 
    { id: this.currentYear },
    { id: this.currentYear + 1 }
  ];
  
  retestSearch: RetestSearch = {
    id: '',
    wellId: 0,
    orgininalSampleId: '',
    retestSampleId: '',
    voucherId: 0,
    voucherIdentifier: '',
    householdId: '',
    retestQuarter: '',
    retestYear: '',
    tier: '',
    isComplete: '',
    completedDate: '',
    dueBy: '',
    isSelected: false,
    wellAddress: '',
    customerName: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    phone: '',
    email: '',
    wellCounty: '',
    mismatchedTier: false,
    incomplete: false,
    incompleteReason: ''
  };

  
  retestLubgwmaWellRetestType = "LUBGWMA Well Retest";

  searchForm = new FormGroup({
    id: new FormControl(),
    sampleId: new FormControl(),
    voucherIdentifier: new FormControl(),
    householdId: new FormControl(),
    retestYear: new FormControl(),
    retestQuarter: new FormControl(),
    tier: new FormControl(),
    isComplete: new FormControl(),    
    wellCounty: new FormControl(),
    mismatchedTier: new FormControl(false)
  });

  haveSearchResults = false;
  searchResultsCount = 0;
  searchResults: RetestSearch[] = [];

  constructor(private toastr: ToastrService, private http?: HttpClient) { }

  deleteBulkJob(id: number): Observable<any> {
    return this.http.get<any>(environment.privateApi + 'Retests/DeleteBulkJob/' + id, httpOptions);
  }

  deleteRetest(id: number): Observable<any> {
    return this.http.get<any>(environment.privateApi + 'Retests/Delete/' + id, httpOptions);
  }

  getRetest(id: number): Observable<Retest> {
    return this.http.get<Retest>(environment.privateApi + 'Retests/Edit/' + id, httpOptions);
  }

  getVoucherRetests(voucherId: number): Observable<Retest[]> {
    return this.http.get<Retest[]>(environment.privateApi + 'Retests/Voucher/' + voucherId, httpOptions);
  }

  getHouseholdRetests(householdId: number): Observable<Retest[]> {
    return this.http.get<Retest[]>(environment.privateApi + 'Retests/Household/' + householdId, httpOptions);
  }

  saveRetest(retest: Retest): Observable<any> {
    return this.http.post(environment.privateApi + 'Retests/SaveRetest', retest, httpOptions);
  }

  addRetest(retest: Retest): Observable<any> {
    return this.http.post(environment.privateApi + 'Retests/AddRetest', retest, httpOptions);
  }

  search(search: RetestSearch): Observable<RetestSearch[]> {
    return this.http.post<RetestSearch[]>(environment.privateApi + 'Retests/Search', search, httpOptions);
  }

  getBulkJobs(): Observable<BulkJob[]> {
    return this.http.get<BulkJob[]>(environment.privateApi + 'Retests/CocBulkjobs', httpOptions);
  }

  downloadBulkCocJob(id: number): Observable<Blob> {
    return this.http.get<Blob>(environment.privateApi + 'Retests/DownloadBulkJobFile/' + id, { responseType: 'blob' as 'json', withCredentials: true });
  }
  
  async uploadCoCLetters(bulkJob: BulkJob) {
    this.http.post(environment.privateApi + 'Retests/UploadCocLetters', bulkJob, httpOptions).toPromise();
  }

  bulkOperation(bulkOperation: RetestBulkOperation): Observable<any> {
    console.log(JSON.stringify(bulkOperation));
    return this.http.post<any>(environment.privateApi + 'Retests/BulkOperation', bulkOperation, httpOptions);
  }
  
}